import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=a0fe114e&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe114e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fe114e')) {
      api.createRecord('a0fe114e', component.options)
    } else {
      api.reload('a0fe114e', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=a0fe114e&scoped=true", function () {
      api.rerender('a0fe114e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Heading.vue"
export default component.exports